import script from "./PageUnavailable.vue?vue&type=script&setup=true&lang=js"
export * from "./PageUnavailable.vue?vue&type=script&setup=true&lang=js"

import "./PageUnavailable.vue?vue&type=style&index=0&id=65e12cbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e12cbd"]])

export default __exports__